import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/outline";
import { classNames } from "utils";
function RadioCards({ options, isInShareCapital = false }) {
  return (
    <div
      className={
        options?.length > 2
          ? `grid grid-cols-3 mt-4 gap-y-6 sm:grid-cols-6 sm:gap-x-6 ${
              isInShareCapital ? "bg-white rounded p-4" : null
            }`
          : "grid grid-cols-2 mt-4 gap-y-6 sm:grid-cols-4 sm:gap-x-4"
      }
    >
      {options?.map((option) => (
        <RadioGroup.Option
          key={option?.id}
          value={option}
          disabled={option?.disabled}
          className={({ checked, active }) =>
            classNames(
              checked ? "border-transparent" : "border-gray-300",
              active ? "ring-2 ring-indigo-500" : "",
              option?.disabled ? "cursor-not-allowed" : "cursor-pointer",
              "col-span-2 relative bg-white border rounded-lg shadow-sm p-4 flex focus:outline-none select-none"
            )
          }
        >
          {({ checked, active }) => (
            <>
              <div className="flex flex-1">
                <div className="flex flex-col">
                  {option?.icon ? (
                    <div className="w-14 h-14">{option?.icon}</div>
                  ) : null}

                  <RadioGroup.Label
                    as="span"
                    className="block text-sm font-medium"
                  >
                    {option?.title}
                  </RadioGroup.Label>
                  <RadioGroup.Description
                    as="span"
                    className="flex items-center mt-1 text-sm"
                  >
                    {option?.description}
                  </RadioGroup.Description>
                </div>
              </div>
              <CheckCircleIcon
                className={classNames(
                  !checked ? "invisible" : "",
                  "h-5 w-5 text-indigo-600"
                )}
                aria-hidden="true"
              />
              <div
                className={classNames(
                  active && !checked ? "border" : "border-2",
                  checked ? "border-indigo-500" : "border-transparent",
                  "absolute -inset-px rounded-lg pointer-events-none"
                )}
                aria-hidden="true"
              />
            </>
          )}
        </RadioGroup.Option>
      ))}
    </div>
  );
}

export default RadioCards;
